import { MarketplacePage } from "PFApp/marketplace/constants/marketplace_page";
import { WorkOpportunitiesTab } from "PFApp/marketplace/constants/work_opportunities_tab";
import { useMarketplaceCounters } from "PFApp/marketplace/hooks/use_marketplace_counters";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useUnreadFilter } from "../../../hooks/use_unread_filter";
import { Tile } from "../../components";
import { CounterTile } from "../../components/counter_tile";
import css from "./opportunities.module.scss";

export const Opportunities = () => {
  const history = useHistory();
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard.opportunities" });
  const { savedActivitiesCount, sharedActivitiesCount, interestedActivitiesCount, unreadActivitiesCount } =
    useMarketplaceCounters({ observerId: MarketplacePage.Dashboard });
  const { serialize } = useUnreadFilter();

  return (
    <Tile
      title={t("title")}
      onClick={() => history.push("/marketplace/work_opportunities/matching_roles")}
      label={t("action")}
      iconName="role"
    >
      <div className={css.countersContainer}>
        <CounterTile
          title={t("counters.unread")}
          code="unread"
          onClick={() =>
            history.push(
              `/marketplace/work_opportunities/${WorkOpportunitiesTab.MatchingRoles}?${serialize(true)}`
            )
          }
          counter={unreadActivitiesCount}
        />
        <CounterTile
          title={t("counters.interested")}
          code="interested"
          onClick={() => history.push(`/marketplace/work_opportunities/${WorkOpportunitiesTab.Interested}`)}
          counter={interestedActivitiesCount}
        />
        <CounterTile
          title={t("counters.saved")}
          code="saved"
          onClick={() => history.push(`/marketplace/work_opportunities/${WorkOpportunitiesTab.SavedRoles}`)}
          counter={savedActivitiesCount}
        />
        <CounterTile
          title={t("counters.shared")}
          code="shared"
          onClick={() => history.push(`/marketplace/work_opportunities/${WorkOpportunitiesTab.SharedWithMe}`)}
          counter={sharedActivitiesCount}
        />
      </div>
    </Tile>
  );
};
